import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StickyChatComponent } from './sticky-chat.component';
import { YouChatModule } from '../you-chat/you-chat.module';
import { BlacklistService } from 'app/_service/blacklist/blacklist.service';
import { SharedModule } from 'app/components/shared.module';



@NgModule({
  declarations: [
    StickyChatComponent
  ],
  imports: [
    CommonModule,
    YouChatModule,
    SharedModule,
  ],
  exports: [
    StickyChatComponent,
  ],
  providers: [
    BlacklistService,
  ],
})
export class StickyChatModule { }
